<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'redes') {
            next({ name: 'pro-rede-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'redes') {
            this.$router.push({ name: 'pro-rede-list' });
        }
    },
};
</script>
